import React from 'react';
import {
  Button,
} from '@mui/material';
import PropTypes from 'prop-types';
import DeleteIcon from '@mui/icons-material/Delete';
import useStyles from './styles';

export default function DeleteButton({ setOpenModal, destination, modal }) {
  const classes = useStyles();

  const handleDeleteButtonClick = () => {
    setOpenModal(modal, true);
  };

  return (
    <Button
      onClick={handleDeleteButtonClick}
      startIcon={<DeleteIcon fontSize="large" />}
      type="file"
      variant="contained"
      color="secondary"
      component="span"
      className={classes.button}
    >
      {`Delete ${destination}`}
    </Button>
  );
}

DeleteButton.propTypes = {
  setOpenModal: PropTypes.func.isRequired,
  destination: PropTypes.string.isRequired,
  modal: PropTypes.string.isRequired,
};
